
export const BRANDS = {
    DUFA: {
        id: 'dufa',
        name: 'Düfa',
        logo: '/img/dufa-logo.png',
        primaryColor: '#5AA668',
        secondaryColor: '#2E5C8A',
        description: 'Alman teknolojisi ile üretilen üstün kaliteli inşaat boyaları.',
        website: 'www.dufa.com.tr',
        categories: ['İç Cephe', 'Dış Cephe', 'Tavan', 'Ahşap & Metal'],
        theme: {
            light: 'radial-gradient(circle at 50% 120%, #5AA668 0%, #f9f9f9 70%)',
            dark: 'radial-gradient(circle at 50% 120%, #5AA668 0%, #0f172a 70%)'
        }
    }
};

export const DEFAULT_BRAND = BRANDS.DUFA;
